module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp1",
    attrs: {
      "id": "ill"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ILL-H"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("ILLUSTRATIONS AND MAPS")])]), _vm._v(" "), _c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Henry Tudor, sixteenth-century portrait "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(Society of Antiquaries of London/Bridgeman)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Richard Plantagenet, sixteenth-century portrait "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(Society of Antiquaries of London/Bridgeman)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Funeral effigy of Katherine of Valois "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(Dean and Chapter of Westminster)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brass rubbing from the tomb of Edmund Tudor "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(Geoffrey Wheeler)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Margaret Beaufort, sixteenth-century portrait "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(Philip Mould Ltd, London/Bridgeman)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pembroke Castle "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(Getty Images)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Henry VI, c. 1540 "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(The National Portrait Gallery, London)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Margaret of Anjou, detail from Shrewsbury Talbot book of Romances "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(AKG Images/British Library)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edward IV, early sixteenth-century portrait "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(Society of Antiquaries of London/Bridgeman)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Elizabeth Woodville, sixteenth-century portrait "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(Philip Mould Ltd/ Bridgeman)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A miniature of the presentation of "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Dictes and Sayings of the Philosophers ")]), _vm._v("at the court of Edward IV, with Edward V as the Prince of Wales "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(Lambeth Palace Library/Bridgeman)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Portrait of Elizabeth of York, c. 1500 "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(The National Portrait Gallery, London)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Detail from the Rous Roll, 1480 "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(AKG Images/British Library)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brass rubbing of William Catesby "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(Geoffrey Wheeler)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stained-glass window depicting Lord Howard, 1st Duke of Norfolk "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(Geoffrey Wheeler)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Henry Tudor, sixteenth-century French drawing "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(Giraudon/Bridgeman)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tomb of Duke Francis II in Nantes Cathedral, Brittany "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(Olaf Lange)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Louis XI, 1470 "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(André Held/AKG Images)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Charles VIII, 1485 "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(AKG Images)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo17#photo17-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Anne de Beaujeu, from the right wing of the Bourbon Altarpiece, Moulins Cathedral "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(Giraudon/Bridgeman)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Château de Suscinio, Sarzeau, France "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(hemis.fr/Getty Images)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Château de Largoët, Elven, France "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(hemis.fr/Getty Images)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Drawing of the tomb of John de Vere, 13th Earl of Oxford "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(British Library)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stained-glass window depicting Reginald Bray "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(Geoffrey Wheeler)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brass rubbing of Christopher Urswick "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(Geoffrey Wheeler)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mill Bay, Pembrokeshire "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(Author photo)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tomb of Rhys ap Thomas, St Peter’s Church, Carmarthen "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(Geoffrey Wheeler)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Merevale Church, Warwickshire "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(Author photo)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Engraving of the Welsh Gate, Shrewsbury, by Hugh Owen "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(Geoffrey Wheeler")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Blue Boar Inn, Leicester "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(Geoffrey Wheeler)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brass rubbing of Sir Gervase Clifton "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(Geoffrey Wheeler)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brass rubbing of Roger Wake "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(Geoffrey Wheeler)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tomb of Simon Digby in Coleshill Church, Warwickshire "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(Geoffrey Wheeler)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tomb of Sir John Cheyney in Salisbury Cathedral "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(Geoffrey Wheeler)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The fields where Richard III’s last stand might have taken place "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(Author photo)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Battle of Bosworth, sixteenth-century relief "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(Stowe School/SHPT)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The view of the battlefield at Bosworth from the top of St Margaret’s Church, Stoke Golding "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(Author photo)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gold signet ring showing Richard III’s insignia "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(Geoffrey Wheeler)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cannon balls discovered at the battlefield site "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(Bosworth Battlefield Heritage Centre)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bosworth Crucifix "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(Society of Antiquaries)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Silver gilt boar badge discovered at the battlefield site ("), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Bosworth Battlefield Heritage Centre)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Broken sword handle "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(Bosworth Battlefield Heritage Centre)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Annunciation, from Richard III’s book of hours, Ms 474 ff14v-15 "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(Lambeth Palace Library/Bridgeman)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lead badge representing the Yorkist sun "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(Bosworth Battlefield Heritage Centre)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gold badge of an eagle with a snake "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(Bosworth Battlefield Heritage Centre)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The gravesite of Richard III in Leicester City Council Social Services car park "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(University of Leicester)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The bones of Richard III "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(University of Leicester)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Richard III’s skull "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(University of Leicester)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("St James’ Church, Dadlington "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(Author photo)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Henry VII, terracotta bust by Pietro Torrigiano, c. 1509–11 "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(Victoria & Albert Museum, London/Bridgeman)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }), _vm._v(" "), _c('p', {
    staticClass: "ILL-H1"
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("MAPS")])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/map#map"
    }
  }, [_vm._v("England, France and Brittany during the Wars of the Roses")])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#map2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The march to Bosworth Field")])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#map3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The positions and movements of the forces at the battle of Bosworth")])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }), _vm._v(" "), _c('p', {
    staticClass: "ILL-H1"
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("APPENDIX")])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix#app1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Polydore Vergil’s Manuscript, Biblioteca Apostolica Vaticana, Urbini Latini 498 fos. 434v–435 "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(by permission of Biblioteca Apostolica Vaticana, all rights reserved)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-119334d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/illust_maps.vue
// module id = 69
// module chunks = 0